import { post, get, upload } from '@/utils/network';

// 检测手机号是否绑定在其他账号上
export const checkMobile = (mobile: string) => post('/UserApi/checkMobile', { mobile });
export const changeRole = (param: object) => post('/UserApi/changeRole', param);
export const getCollegeList = (param: object) => post('/InformationSupplementApi/getCollegeList', param);
export const getMajorLists = (param: object) => post('/InformationSupplementApi/getMajorLists', param);
export const updateInfo = (param: object) => post('/UserApi/updateInfoV2', param);
// 上传头像
export const uploadAvatar = (param: object) => post('UploadApi/uploadAvatarByCrop', param);
export const unbindWechat = () => post('/UserApi/unbindWechat');
export const bindWechatQrcode = (param?: object) => post('/Wechat/qrcodeV2',param);
//判断绑定情况
export const isBindWechat = (param?: object) => post('/UserApi/isBindWechat',param);
export const isBindOtherWechat = (param?: object) => post('/UserApi/isBindOtherWechat',param);
// 发送邮箱验证码
export const sendEmailCode = (param: object,showError?:boolean) => post('/UserApi/sendEmailCode', param, showError);
export const updateEmail = (param: object) => post('/UserApi/updateEmailByVerifyCode', param);
export const unbindEmail = () => post('/UserApi/unbindEmail');
// 获取交易记录
export const getTradingRecord = (param: object) => post('/VipApi/getTradingRecord', param);

export const getFigureCode = () => post('/UserApi/getFigureCode');
// 验证验证码是够正确
export const checkVerify = (param: object,showError?:boolean) => post('/UserApi/sendCode', param, showError);

// 更换手机号
export const updateMobile = (param: object) => post('/UserApi/updateMobile', param);
export const updatePassword = (param: object) => post('/UserApi/updatePassword', param);
export const unbindSendCode = (param: object) => post('/UserApi/unbindSendCode', param);
// 解除绑定手机
export const unbindPhone = (param: object) => post('/UserApi/unbindPhone', param);
// 课堂成员变动开关
export const setMessageOpen = (param: object) => post('/UserApi/setAddClassEmailNotify', param);
// 作业开关
export const setHomeWorkOpen = (param: object) => post('/UserApi/switchHomeworkEmailNotify', param);
// 私信开关
export const setLetterOpen = (param: object) => post('/UserApi/switchLetterNotify', param);
// 话题开关
export const setCovOpen = (param: object) => post('/UserApi/switchTopicNotify', param);
// 获取所有消息
export const messageLists = (param: object) => post('/MessageApi/lists', param);
// 获取机构发送的消息
export const getAgencyMsg = (param: object) => post('/MessageApi/getAgencyMsg', param);
export const readMessageIt = (param: object) => post('/MessageApi/readIt', param);
// 忽略消息
export const readAll = (param: object) => post('/MessageApi/readAll', param);

export interface InterfaceInvoice {
  title: string; // 标题
  type: string; // 类型0企业 1 个人
  invoiceno: string; // 税务登记证号
  bankname: string; // 基本开户银行名称
  bankaccount: string; // 基本开户账号
  registeraddress: string; // 注册场所地址
  registertel: string; // 注册固定电话
  orderno?: string[]; // 订单列表
  invoicetype?:string;//发票方式，0表示电子发票，1表示纸张发票
  email?:string;//申请人邮箱
  telphone?:string;//申请人电话
  recipients?:string;//收件人
  deliveryaddress?:string;//收件地址
}

// 添加用户发票信息第一步
export const addUserInvoiceInfo = (param: InterfaceInvoice) => post('VipActivityApi/addUserInvoiceInfo', param);
// 添加用户发票信息第二步
export const addInvoiceApply = (param:{}) => post('/VipActivityApi/addInvoiceApply', param);
// 验证机构
export const userAttest = (param: object) => post('/UserApi/userAttest', param);
// 被绑定对象课程教学班
export const teachClass = (param: object) => post('/CourseApi/teachClass', param);
// 确认认证
export const relationTeachClass = (param: object) => post('/CourseApi/relationTeachClass', param);
// 获取用户认证机构列表
export const getUserAgencyInfo = () => post('/FutureV2/UserApi/getUserAgencyInfo');
// 解除用户和某个机构的绑定关系
export const dismissUserAgency = (params: {coid: string; name: string; stno: string}) => post('/FutureV2/UserApi/dismissUserAgency', params);
// 变更用户机构绑定关系
export const setUserAgency = (params: {source_coid: string; coid: string; name: string; stno: string}) => post('/FutureV2/UserApi/setUserAgency', params);
// 直接更新邮箱
export const replaceEmail = ({ email, password }: { email: string; password: string }) => post('/UserApi/updateEmail', { email, password });
// 验证用户是否绑定了腾讯会议（验证用户是否绑定了手机号&邮箱）
export const isUserBindTencent = (courseid: string) =>
  post<{
    emailFailCode: number | string;
    mobileFailCode: number | string;
  }>('/Futurev2/TencentMeeting/isUserBindTencent', { courseid });

export default {
  getFigureCode,
  checkVerify
};
